import Loadable from 'react/components/loadable';

const ShowProductDrawer = Loadable({
  loader: () => import('../../pages/pos/products/show_product_drawer'),
  type: 'drawer',
});

angular.module('gym').value('ShowProductDrawer', ShowProductDrawer);
